export const HEATMAP_GROUPS = {
  VN30: 'ACB,BID,CTG,FPT,GAS,GVR,HDB,HPG,MBB,MSN,MWG,PLX,DGC,LPB,SHB,SSB,VIB,VPL,SAB,SSI,STB,TCB,TPB,VCB,VHM,VIC,VJC,VNM,VPB,VRE',
  'Ngân hàng': 'ABB,ACB,BID,BVB,CTG,HDB,LPB,MBB,MSB,NAB,OCB,SHB,STB,TCB,TPB,VCB,VIB,VPB,EIB',
  'Chứng khoán': 'AAS,AGR,APG,BSI,BVS,CTS,EVF,EVS,FTS,HCM,MBS,SBS,SHS,SSI,VCI,VDS,VIX,VND,APS,ORS,TVB,TVS,BMS,TCI,VFS',
  Thép: 'HPG,HSG,NKG,SMC,TVN,VGS,NSH',
  'Dầu khí': 'BSR,CNG,GAS,OIL,PET,PLX,POW,PVB,PVC,PVD,PVS,PVT,PLC',
  'Bảo hiểm': 'BVH,BMI,MIG',
  'Bất động sản': 'CCL,CEO,DIG,DPG,DXG,HDC,HDG,HQC,IJC,KDH,NDN,NTL,NVL,NLG,PDR,SCR,TCH,HTN,IDJ,ITC,NHA,DXS,QCG,CII',
  'Bất động sản KCN': 'D2D,GVR,IDC,KBC,LHG,PHR,SIP,SZC,TIP,DTD',
  'Xây dựng - Vật liệu xây dựng': 'VC7,MST,VC3,ACC,QNC,SCL,VGC,BCE,CSC,TTB,C69,CRC,HID,HVH,LIG,PAS,S99,SCG,SCI,TLD,EVG,CTD,PHC,CKG',
  'Đầu tư công': 'BCC,BTS,C47,C4G,CTI,DHA,FCN,G36,HOM,HT1,KSB,LCG,SD5,SD6,TCD,THG,TV2,HHV,VCG,HUT',
  'Cao su': 'DPR,DRC,DRI,GVR,PHR,HNG',
  'Dệt may': 'ADS,GIL,MSH,STK,TCM,TNG,VGT',
  'Than - Khoáng sản': 'CLX,KSB,MDC,NBC,NNC,TDN,THT,TVD,VEF,CST,BMC,DHM,KHB,KSQ,MSR,TC6,TNT',
  'Thủy sản': 'ACL,ANV,ASM,CMX,FMC,IDI,MPC,VHC',
  'Thực phẩm - Xuất khẩu': 'DBC,DHC,LTG,MHC,MSN,NAF,PTB,TNA,VCS,VLC,VNM,VOC,BNA',
  'Hóa chất - Phân bón': 'BFC,CSV,DCM,DDV,DGC,DPM,LAS',
  'Công nghệ': 'ELC,FPT,ITD,TTN,CTR,VGI,MFS,VTP,CMG',
  'Cảng - Vận tải': 'DXP,GMD,HAH,PVP,PVT,SGP,SKG,TCL,VIP,VOS,VSC,VTO,GSP,TCO',
  'Dịch vụ': 'HAX,PAN,TCT,VNG,VTP',
  'Điện - Năng lượng': 'PPC,PVG,QTP,TTA,GEG,SJD,NT2,REE,PC1,GEX,VNE,REE,SAM',
  'Họ Vingroup': 'VHM,VIC,VRE,VPL',
  'Đường - Gỗ': 'GDT,LSS,QNS,SBT,TTF',
  'Hàng không - Du lịch': 'HVN,VJC,VTD,DAH,RIC',
  'Nước - Nhựa': 'AAA,APH,BMP,BWE,DAG,NTP,TDM,HII,NHH,PLP',
  'Bán lẻ': 'DGW,PET,MSN,MWG,PNJ,FRT',
  'Y tế - Dược phẩm': 'DCL,DHG,DBD,JVC,TNH',
}

export function getGroupTickers(groupName) {
  const csv = HEATMAP_GROUPS[groupName] || ''

  return csv ? csv.split(',') : []
}
